export const environment = {
  production: true,
  buildId: '3055001144520231',
  configFile: 'config.json',
};
